/**
 * @desc 登录bpm网关
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/sys/user/login/bpmGateway/login`, {
      method: "POST",

      ...options,
    }),
  );
}
